// apps/api/src/qxcircle/qxcircle-feed-seeds.ts
// Description: QXCircle feed bootstrap — empty on product; lab data in qxcircle-lab-fixtures.
// Owner: Masa Bayu
// Date: 2026-08-30

import type { QxCircleFeedPost } from "./qxcircle.types";

export function seedQxCircleFeed(): QxCircleFeedPost[] {
  return [];
}
